import React from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import SettingsChangeDefaultBranchContent from "./SettingsChangeDefaultBranchContent";
import { SettingsChangeDefaultBranchButton } from "./widget/SettingsChangeDefaultBranchBody";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import { SettingsChangeDefaultBranchContextProvider } from "../../../provider/settings/change_default_branch/SettingsChangeDefaultBranchContextProvider";

const SettingsChangeDefaultBranchScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <SettingsChangeDefaultBranchContextProvider>
      <Scaffold
        appBarTitle={AppTranslation.text("change_default_branch")}
        bottomNavigationButton={
          <SettingsChangeDefaultBranchButton type={type} />
        }
      >
        <MainBodyContainer>
          <SettingsChangeDefaultBranchContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </SettingsChangeDefaultBranchContextProvider>
  );
};

export default SettingsChangeDefaultBranchScreen;
export const routeName: string = "/settings/change-default-branch";
